import { useEffect, useMemo } from "react"
import { useLazyLoadQuery } from "react-relay"
import { graphql } from "relay-runtime"
import { previewDocumentFullScreenDialogMediaFilesQuery } from "@/components/__generated__/previewDocumentFullScreenDialogMediaFilesQuery.graphql"
import { PreviewDocumentDialog } from "@/components/preview-document-dialog"
import { SofiaEnvironment } from "@/sofia-environment"
import { usePreviewDocumentDialogStore } from "@/stores/usePreviewDocumentDialogStore"

const mediaFilesAppointmentByIdQuery = graphql`
  query previewDocumentFullScreenDialogMediaFilesQuery($id: ID!) {
    appointmentById(id: $id) {
      appointmentAttachments {
        attachmentType
        fileName
        id
        thumbnailUrl
        uploadDate
        uploadedBy
        uploadSource
        uploadStatus
        url
      }
    }
  }
`

export const PreviewDocumentDialogFullScreenWrapper = ({
  previewDocumentAppointmentId,
  mediaFileId,
}: {
  previewDocumentAppointmentId: string
  mediaFileId: string
}) => {
  const mediaFiles = usePreviewDocumentDialogStore((s) => s.mediaFiles)
  const setMediaFiles = usePreviewDocumentDialogStore((s) => s.setMediaFiles)
  const setIndex = usePreviewDocumentDialogStore((s) => s.setIndex)

  const { appointmentById } = useLazyLoadQuery<previewDocumentFullScreenDialogMediaFilesQuery>(
    mediaFilesAppointmentByIdQuery,
    {
      id: previewDocumentAppointmentId,
    },
  )

  const mediaFilesData = useMemo(() => {
    return appointmentById?.appointmentAttachments
      .filter((a) => a.uploadSource !== "DOC2_U")
      .map((a) => ({
        ...a,
        url: `${SofiaEnvironment.Bff.Url}/${a.url}`,
        thumbnailUrl: a.thumbnailUrl ? `${SofiaEnvironment.Bff.Url}/${a.thumbnailUrl}` : null,
      }))
  }, [appointmentById])

  const fileIndex = useMemo(
    () => appointmentById?.appointmentAttachments.findIndex((a) => a.id === mediaFileId) ?? 0,
    [appointmentById, mediaFileId],
  )

  useEffect(() => {
    if (!mediaFiles && mediaFilesData) {
      setMediaFiles(mediaFilesData)
      setIndex(fileIndex)
    }
  }, [fileIndex, mediaFiles, mediaFilesData, setIndex, setMediaFiles])

  if (!mediaFiles) return null

  return <PreviewDocumentDialog mediaFiles={mediaFiles} isMediaFilesDataFromPrams={true} />
}
